export default __webpack_public_path__ + "static/media/default.522560c8.png";